module.exports = __webpack_public_path__ + "img/marmelaedchen-enten_xs.7aa3704c.jpg";